import React from 'react';

interface Props {
  open: boolean;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}
const OVERLAY =
  'fixed inset-0 z-[10000] bg-[rgba(19,22,40,0.52)] grid place-items-center p-5 backdrop-blur-[3px]';
const DIALOG =
  'w-[min(440px,100%)] bg-white rounded-2xl p-7 shadow-[0_24px_70px_rgba(0,0,0,0.24)]';
const ICON =
  'w-12 h-12 rounded-full grid place-items-center bg-[#fff4e5] text-[#b45309] text-[1.4rem] mb-4';
const TITLE = 'text-[1.2rem] text-[#1f2937] m-0 mb-2.5';
const COPY = 'text-[0.9rem] text-[#62677a] leading-[1.7] m-0 mb-[22px]';
const ACTIONS = 'flex justify-end gap-2.5';
const BUTTON_BASE =
  'min-h-[42px] py-0 px-[17px] rounded-lg font-bold cursor-pointer border';
const BUTTON_DEFAULT = 'border-gray-300 bg-white text-gray-700';
const BUTTON_DANGER = 'border-red-600 bg-red-600 text-white';
const SignupSkipConfirmation: React.FC<Props> = ({
  open,
  busy,
  onCancel,
  onConfirm,
}) =>
  open ? (
    <div className={OVERLAY} role="presentation" onMouseDown={onCancel}>
      <div
        className={DIALOG}
        role="dialog"
        aria-modal="true"
        aria-labelledby="skip-title"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className={ICON}>!</div>
        <h2 className={TITLE} id="skip-title">
          本当にオンボーディングをスキップしますか？
        </h2>
        <p className={COPY}>
          スキップすると、初回限定の無料バナー10枚を作成できなくなります。この操作は元に戻せません。
        </p>
        <div className={ACTIONS}>
          <button
            className={`${BUTTON_BASE} ${BUTTON_DEFAULT}`}
            type="button"
            onClick={onCancel}
          >
            戻る
          </button>
          <button
            className={`${BUTTON_BASE} ${BUTTON_DANGER}`}
            type="button"
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? '処理中...' : 'スキップする'}
          </button>
        </div>
      </div>
    </div>
  ) : null;
export default SignupSkipConfirmation;
